<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-04-09 09:51:25
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-04-09 10:55:05
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/wemeet-poster/src/views/mini-h5/pages/my_home_page/components/MainPageResume.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div class="box">
    <div class="descBox">
      <div class="leftItem">
        <div class="name">个人履历</div>
        <div class="desc">您还没有个人履历，点击加号编辑</div>
      </div>
      <div class="rightItem">
        <img src="" class="addIcon" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Mainpageintroduction',

  data() {
    return {}
  },

  mounted() {},

  methods: {},
}
</script>


<style lang="less" scoped>
.box {
  padding:0 14px;
  box-sizing: border-box;
  .descBox {
    width: 100%;
    min-height: 75px;
    background: #ffffff;
    border-radius: 10px;
    padding: 16px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .leftItem{
      width:80%;
      text-align: left;
      .name{
        font-size: 16px;
        color: #262626;
        font-weight: bold;
      }
      .desc{
        color: #8c8c8c;
        font-size: 12px;
        margin-top: 10px;
      }
    }
    .rightItem{
      width: 20%;
      .addIcon{
        width: 18px;
        height: 18px;
      }
    }
  }
}
</style>